<template>
  <div>
    <a-list
      :bordered="bordered"
      item-layout="vertical"
      size="large"
      :loading="loading"
      :pagination="pagination"
      :data-source="newsListData"
    >
      <a-list-item slot="renderItem" key="item.scr" slot-scope="item">
        <div   @click="sleNewEdit($event,item.title)" class="certificateListBox acea-row">
          <div class="right_box row-center-wrapper acea-row row-column">
            <div
              :style="`backgroundImage: url(` + item.image + `)`"
              class="productImg"
            ></div>
          </div>
          <div class="left_box acea-row row-column">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.time }}</div>
            <div class="content_text">{{ item.content }}</div>
          </div>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
  props: ["newsList"],
  data() {
    return {
      loading: true,
      bordered: false,
      pagination: {
        onChange: (page) => {
          console.log(page, "ff");
          this.nowPage = page;
        },
        position: "bottom",
        pageSize: 3,
      },
      nowPage: 1,
      newsListData: [],
    };
  },
  methods:{
     /**
     *  查看新闻详情
     * 
     */
    sleNewEdit:function(e,title){
        console.log("查看新闻详情",title);
         this.$router.push({path:'/NewEdit',query:{title:title}});
    }
  },
  created: function () {
    this.newsListData = this.newsList;
    this.loading = false;
    },
  mounted: function () {
    console.log("this1", this.newsList);
  },
};
</script>
<style scoped>
.certificateListBox {
  width: 80%;
  margin: 0px 10%;
  padding: 30px;
  border-radius: 15px;
  flex-wrap: nowrap;
}
.certificateListBox:hover {
  background-color: #fff;
  box-shadow: 0 0 10px 0px rgba(115, 115, 116, 0.5);
  animation: pulse; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1.5s; /* don't forget to set a duration! */
  /* 注释 */
}
.certificateListBox .right_box .productImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 280px;
  height: 185px;
  border-radius: 20px;
}
.certificateListBox .left_box {
  margin-left: 30px;
}
.certificateListBox .left_box .title {
  color: #0e3f6f;
  font-size: 22px;
  font-weight: bolder;
  margin-bottom: 15px;
}
.certificateListBox .left_box .time {
  color: #969696;
  font-size: 18px;
  margin-bottom: 15px;
}
.certificateListBox .left_box .content_text {
  color: #646464;
  font-size: 22px;
  margin-bottom: 15px;
  width: 95%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
/* 去除边框 */
.ant-list-something-after-last-item
  .ant-spin-container
  > .ant-list-items
  > .ant-list-item:last-child {
  border: none;
}
.ant-list-split .ant-list-item {
  border: none;
}
/* 底部分页位置 */
.ant-list-pagination {
  margin-top: 24px;
  text-align: center;
}
@media screen and (max-width: 850px) {
  .certificateListBox {
    flex-direction: column;
    width: 100%;
    margin: 0px 0%;
  }
  .certificateListBox .right_box .productImg {
    width: 100%;
    height: 405px;
    border-radius: 0px;
    margin-bottom: 40px;
  }
  .certificateListBox .left_box .title {
    font-size: 28px;
    color: #515254;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newList/index.vue